import type React from 'react';

import { Grid } from '@change/ds-layout';

import { DismissButton } from '../shared/components/DismissButton';
import { useBanner } from '../shared/hooks/useBanner';

import { Content } from './components/Content';
import { PhoneImage } from './components/PhoneImage';
import { QRCode } from './components/QRCode';

type Props = {
	sourceLocation: string;
	setBannerClosed: () => void;
};

export const DesktopBanner: React.FC<Props> = ({ sourceLocation, setBannerClosed }) => {
	const {
		actions: { onClickClose },
	} = useBanner({ sourceLocation, setBannerClosed });

	return (
		<div
			id="app-download-bottom-banner"
			className="text-typography-strong dark:bg-background-raised border-stroke-weaker bg-gradient-background-light-1 fixed bottom-0 left-0 z-30 hidden w-full border-t border-solid py-9 shadow-[0px_10px_20px_0px_rgba(24,25,31,0.1)] md:block dark:bg-none"
			data-testid="app-download-bottom-banner"
			role="alert"
		>
			<DismissButton className="absolute top-6 right-6 z-1" onClick={onClickClose} />
			<Grid className="items-center py-4">
				<div className="col-span-4 md:col-span-2">
					<QRCode />
				</div>
				<div className="col-span-4 md:col-span-5 lg:col-span-7">
					<Content />
				</div>
				<div className="hidden justify-self-end lg:col-span-3 lg:block">
					<PhoneImage />
				</div>
			</Grid>
		</div>
	);
};
